import React from 'react';
import etgLogo from '../assets/etg.png';
import ufmgLogo from '../assets/Ufmg-sem nome-03.png';
import '../styles/home.css';

const PrivacyPolicy = () => {
  return (
    <div className="tipo-ambiente-container">
      <div className="header-controls">
        <button className="btn-back" onClick={() => window.history.back()}><i className="fas fa-arrow-left"></i></button>
      </div>
      <div className="header">
        <div className="title-container">
          <img src={etgLogo} alt="ETG Logo" className="logo" />
          <h1>Política de Privacidade</h1>
          <img src={ufmgLogo} alt="UFMG Logo" className="logo" />
        </div>
      </div>
      <div className="text-container">
        <h2>1. Informações que Coletamos</h2>
        <p>Podemos coletar informações de identificação pessoal dos usuários de várias maneiras, incluindo, mas não se limitando a, quando os usuários visitam nosso site, se registram no site e em conexão com outras atividades, serviços, recursos ou recursos que disponibilizamos em nosso aplicativo.</p>
        <h2>2. Como Usamos as Informações Coletadas</h2>
        <p>Podemos coletar e usar as informações pessoais dos usuários para os seguintes fins:</p>
        <ul>
          <li>Para melhorar o atendimento ao cliente</li>
          <li>Para personalizar a experiência do usuário</li>
          <li>Para enviar e-mails periódicos</li>
        </ul>
        <h2>3. Como Protegemos Suas Informações</h2>
        <p>Adotamos práticas adequadas de coleta, armazenamento e processamento de dados e medidas de segurança para proteger contra acesso não autorizado, alteração, divulgação ou destruição de suas informações pessoais, nome de usuário, senha, informações de transação e dados armazenados em nosso aplicativo.</p>
        <h2>4. Compartilhando Suas Informações Pessoais</h2>
        <p>Não vendemos, trocamos ou alugamos informações de identificação pessoal dos usuários a terceiros.</p>
        <h2>5. Alterações a Esta Política de Privacidade</h2>
        <p>Temos o poder de atualizar esta política de privacidade a qualquer momento. Quando o fizermos, revisaremos a data de atualização na parte inferior desta página.</p>
        <h2>6. Sua Aceitação Destes Termos</h2>
        <p>Ao usar este aplicativo, você indica sua aceitação desta política.</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;